import packageJson from '../../package.json';

const name = packageJson.name;
const version = packageJson.version;

export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyAqYrMYCPD1t1Ihgxh62EXP0M65R0fLj40",
    authDomain: "church-services-9e609.firebaseapp.com",
    projectId: "church-services-9e609",
    storageBucket: "church-services-9e609.firebasestorage.app",
    messagingSenderId: "632980548175",
    appId: "1:632980548175:web:4a89bb63dd18753a4ed83a",
    measurementId: "G-Z7HYSMNV1W"
  }
  ,
  name,
  version,
  apiHost: 'https://church-services.org/api'
};
